import React from 'react';
import { useDebounceFn } from 'ahooks';
import { Button } from 'tea-component';
import { downloadAction } from '@intelligence/components/DownloadCommon/DownloadPage';
import { buriedBtnPoint } from '@home/utils/buriedPoint';
import { dbiBtnLogMes } from '@intelligence/utils/buriedPointCfg';
import { DEBOUNCE_CONFIG } from '@intelligence/v3/_config/utils';

import type { IBaseProps } from '@intelligence/types/common';

interface IDownloadSimpleProps extends IBaseProps {
  // 是否禁用
  disabled?: boolean;
  // 下载打点配置表里的key
  pageDownloadExcelKey: string;
  // 下载配置的key
  downloadKey: string;
  // 下载接口的入参
  downLoadParams: Record<string, any>;
  // 下载页面的查询参数
  downloadQuery?: IRecord;
}

const DownloadSimple: React.FC<IDownloadSimpleProps> = (props) => {
  const { disabled, pageDownloadExcelKey, downloadKey, downLoadParams, downloadQuery } = props || {};

  const { run: handleDownloadRun } = useDebounceFn(() => {
    handleDownloadLog(pageDownloadExcelKey);

    downloadAction({
      downloadKey,
      downLoadParams,
      downloadQuery,
    });
  }, DEBOUNCE_CONFIG);

  const handleDownloadLog = (key: string) => {
    const btnLogCfg = (dbiBtnLogMes as any)?.[key];
    if (btnLogCfg) {
      buriedBtnPoint(btnLogCfg);
    }
  };

  return (
    <Button
      className="ns-btn--icon trend-justify-btn"
      type="primary"
      icon="download"
      disabled={disabled}
      onClick={(e) => {
        e?.stopPropagation();
        handleDownloadRun();
      }}
    />
  );
};

export default React.memo(DownloadSimple);
